import { render, staticRenderFns } from "./Xreport.vue?vue&type=template&id=2f8b886f&scoped=true"
import script from "./Xreport.vue?vue&type=script&lang=js"
export * from "./Xreport.vue?vue&type=script&lang=js"
import style0 from "./Xreport.vue?vue&type=style&index=0&id=2f8b886f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8b886f",
  null
  
)

export default component.exports